import React from 'react'
import { Dialog } from 'antd-mobile';
import './index.less';

// 自定义dialog
const CustomDialog = ({
  visible,
  title,
  content,
  confirmText = '确认',
  cancelText = '取消',
  showCancelButton = true,
  onConfirm,
  onCancel,
  maskClosable = true
}) => {
  const actions = []

  if (showCancelButton) {
    actions.push({
      key: 'cancel',
      text: cancelText,
      onClick: () => {
        onCancel?.()
      }
    })
  }

  actions.push({
    key: 'confirm',
    text: confirmText,
    bold: true,
    onClick: () => {
      onConfirm?.()
    }
  })

  return (
    <Dialog
      visible={visible}
      title={<div className='dialog-title'>舒小辅提醒</div>}
      content={<div className='dialog-content'>{content}</div>}
      actions={actions}
      onAction={action => action.onClick?.()}
      closeOnMaskClick={maskClosable}
      onClose={onCancel}
    />
  )
}

export default CustomDialog